import { GenreDetailsOut } from '../../../store/apiLibx';

export function createGenreBreadcrumbItems(items: GenreDetailsOut[]) {
    return items.map(item => ({
        key: item.id ?? '',
        value: item.name ?? '',
        docCount: item.docCount ?? 0,
        buckets:
            item.subGenres?.map(subItem => ({
                key: subItem.id,
                value: subItem.name,
                docCount: subItem.docCount ?? 0,
                buckets: []
            })) ?? []
    }));
}
